// @owners { team: patients }
import { Body, Card, Column, H1, LgPadding, MdSpacing, Row } from '@alto/design-system';
import * as React from 'react';

type Props = {
  readonly headerIcon?: React.ReactElement;
  readonly title?: string;
  readonly text?: string;
  readonly centerText?: boolean;
  readonly children: React.ReactElement | React.ReactElement[];
};

export const CommsVerificationCard = ({ headerIcon, title, text, centerText, children }: Props) => {
  return (
    <Card>
      <LgPadding>
        <Column
          stretchItems
          gap="SM"
        >
          {headerIcon && <Row center>{headerIcon}</Row>}
          {title ? <H1 center={centerText}>{title}</H1> : null}
          {text ? <Body center={centerText}>{text}</Body> : null}
        </Column>
        <MdSpacing />
        <Column
          centerHorizontally
          gap="SM"
        >
          {children}
        </Column>
      </LgPadding>
    </Card>
  );
};
